<template>
    <outboxCon bg='#F8F9FC'>
        <div class="achievement">
            <app-title main='我们过往取得的成就' sub='未来，更期待与机构一起推动中国的教育进步'></app-title>
            <img class="left-shadow" src="https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/common/shadow.png">
            <img class="right-shadow" src="https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/common/shadow.png">
            <swiper class="achieve-swiper-box" :options="swiperOption">
                <swiper-slide v-for="(item, index) in achieveList" :key="`ach${index}`">
                    <div class="achieve-box">
                        <img class="achieve-img" :src="item.img">
                        <p class="achieve-des">{{item.des}}</p>
                    </div>
                </swiper-slide>
                <!-- <div class="swiper-button-next" slot="button-next"></div>
                <div class="swiper-button-prev" slot="button-prev"></div> -->
            </swiper>
            <div class="change-box">
                <div class="swiper-button-next" slot="button-next">

                </div>
                <div class="swiper-button-prev" slot="button-prev">

                </div>
            </div>
        </div>
    </outboxCon>
</template>
<script>
import { achieveList } from '@/const/index'
export default {
  data () {
    return {
      swiperOption: {
        notNextTick: true,
        direction: 'horizontal',
        autoplay: false,
        speed: 1000,
        loop: false,
        slidesPerView: 3.4,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      achieveList: achieveList
    }
  }
}
</script>
<style lang="scss" scoped>
    .achievement{
        width: $main-width;
        margin: 0 auto;
        padding: 60px 70px 65px;
        position: relative;
        .left-shadow{
            position: absolute;
            width: 35px;
            height: 430px;
            left: 69px;
            top: 250px;
            z-index: 300;
            transform: rotate(180deg);
        }
        .right-shadow{
            position: absolute;
            width: 35px;
            height: 430px;
            right: 69px;
            top: 250px;
            z-index: 300;
        }
        .achieve-swiper-box{
            margin-top: 124px;
            padding: 40px 0px 80px;
            position: relative;
            .achieve-box{
                width: 320px;
                height: 350px;
                margin-right: 16px;
                background:rgba(255,255,255,1);
                border-radius:6px;
                overflow: hidden;
                transition: transform .5s;
                .achieve-img{
                    width: 320px;
                    height: 207px;
                }
                .achieve-des{
                    padding: 14px;
                    font-size:16px;
                    font-family:PingFang SC;
                    font-weight:400;
                    line-height: 24px;
                    text-align: left;
                }
                &:hover{
                    box-shadow:0px 18px 29px 0px rgba(105,111,127,0.09);
                    transform: scaleY(1.06) scaleX(1.06);
                }
            }
        }
        .change-box{
            .swiper-button-next{
              background: url('https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/common/swiper-left.png');
              width: 175px;
              height: 175px;
              outline: none;
              background-size: 100% 100%;
              right: -25px;
              transform: rotate(-180deg);
              z-index: 800;
            }
            .swiper-button-prev{
              background: url('https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/common/swiper-left.png');
              width: 175px;
              height: 175px;
              outline: none;
              background-size: 100% 100%;
              left: -25px;
              z-index: 800;
            }
            .swiper-button-disabled{
                background: url('https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/common/swiper-arrow-dis.png');
                width: 175px;
                height: 175px;
                outline: none;
                background-size: 100% 100%;
                opacity: 1;
                cursor: pointer;
                &.swiper-button-next{
                    background: url('https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/common/swiper-arrow-dis.png');
                    width: 175px;
                    height: 175px;
                    outline: none;
                    background-size: 100% 100%;
                    right: -25px;
                    transform: rotate(-180deg);
                }
            }
            .swiper-img{
                width: 175px;
                height: 175px;
            }
        }
    }
</style>
